// extracted by mini-css-extract-plugin
export default {"unread":"App_unread__Uv8+r","chatapp":"App_chatapp__y+mcB","chatContainer":"App_chatContainer__CWFz1"};